import type { SVGProps } from "react";
const SvgNumber17 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="66.927pt"
    height="77.642pt"
    viewBox="229.648 -418.729 66.927 77.642"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 237.52,408.275 C 237.939,408.524 238.402,408.682 238.91,408.749 L 252.424,410.537 C 252.741,410.579 253.01,410.502 253.229,410.305 C 253.449,410.108 253.548,409.847 253.527,409.521 L 254.147,344.142 C 254.125,343.816 254.018,343.527 253.825,343.276 C 253.633,343.025 253.378,342.878 253.061,342.836 L 239.927,341.098 C 239.61,341.056 239.341,341.134 239.122,341.331 C 238.902,341.527 238.803,341.789 238.824,342.114 L 238.369,393.087 C 238.327,393.404 238.179,393.546 237.925,393.512 L 231.028,392.212 C 230.33,392.12 229.967,392.427 229.938,393.133 L 229.649,403.36 C 229.628,404.003 229.923,404.461 230.532,404.735 L 237.52,408.275 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 264.591,344.361 C 264.21,344.311 263.94,344.404 263.779,344.641 C 263.619,344.878 263.577,345.196 263.653,345.593 L 278.001,399.589 C 278.141,399.995 278.021,400.173 277.64,400.123 L 269.836,399.09 C 269.582,399.056 269.413,398.873 269.328,398.539 L 269.376,395.253 C 269.355,394.927 269.248,394.638 269.055,394.387 C 268.862,394.135 268.607,393.989 268.29,393.947 L 258.107,392.599 C 257.79,392.558 257.521,392.635 257.301,392.832 C 257.082,393.029 256.982,393.29 257.004,393.616 L 256.968,409.976 C 256.989,410.302 257.096,410.59 257.289,410.842 C 257.482,411.093 257.737,411.24 258.054,411.282 L 293.077,415.916 C 293.394,415.958 293.678,415.882 293.93,415.69 C 294.181,415.497 294.296,415.238 294.275,414.912 L 294.397,403.017 L 294.193,401.635 L 279.597,347.315 C 279.491,346.656 279.12,346.284 278.486,346.2 L 264.591,344.361 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 239.698,411.077 C 240.117,411.326 240.58,411.484 241.088,411.551 L 254.602,413.339 C 254.919,413.381 255.188,413.304 255.407,413.107 C 255.627,412.91 255.726,412.649 255.705,412.323 L 256.325,346.944 C 256.303,346.618 256.196,346.329 256.003,346.078 C 255.811,345.827 255.556,345.68 255.239,345.638 L 242.105,343.9 C 241.788,343.858 241.519,343.936 241.3,344.133 C 241.08,344.329 240.981,344.591 241.002,344.916 L 240.547,395.889 C 240.505,396.206 240.357,396.348 240.103,396.314 L 233.206,395.014 C 232.508,394.922 232.145,395.229 232.116,395.935 L 231.827,406.162 C 231.806,406.805 232.101,407.263 232.71,407.537 L 239.698,411.077 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 266.769,347.163 C 266.388,347.113 266.118,347.206 265.957,347.443 C 265.797,347.68 265.755,347.998 265.831,348.395 L 280.179,402.391 C 280.319,402.797 280.199,402.975 279.818,402.925 L 272.014,401.892 C 271.76,401.858 271.591,401.675 271.506,401.341 L 271.554,398.055 C 271.533,397.729 271.425,397.44 271.233,397.189 C 271.04,396.937 270.785,396.791 270.468,396.749 L 260.285,395.401 C 259.968,395.36 259.699,395.437 259.479,395.634 C 259.26,395.831 259.16,396.092 259.182,396.418 L 259.146,412.778 C 259.167,413.104 259.274,413.392 259.467,413.644 C 259.66,413.895 259.915,414.042 260.232,414.084 L 295.255,418.718 C 295.572,418.76 295.856,418.684 296.108,418.492 C 296.359,418.299 296.474,418.04 296.453,417.714 L 296.575,405.819 L 296.371,404.437 L 281.775,350.117 C 281.669,349.458 281.298,349.086 280.664,349.002 L 266.769,347.163 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber17;
